// FETCH ALL CUTTING_DC_INWARD DETAILS
export const FETCH_CUTTING_DC_INWARD_DETAILS_REQUEST = 'FETCH_CUTTING_DC_INWARD_DETAILS_REQUEST';
export const FETCH_CUTTING_DC_INWARD_DETAILS_SUCCESS = 'FETCH_CUTTING_DC_INWARD_DETAILS_SUCCESS';
export const FETCH_CUTTING_DC_INWARD_DETAILS_FAILURE = 'FETCH_CUTTING_DC_INWARD_DETAILS_FAILURE';

// FETCH ALL CUTTING_DC_INWARD DETAILS
export const FETCH_CUTTING_DC_INWARD_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_CUTTING_DC_INWARD_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_CUTTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_CUTTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_CUTTING_DC_INWARD_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_CUTTING_DC_INWARD_DETAILS_WITHOUT_ID_FAILURE';


export const FETCH_CUTTING_DC_INWARD_BUNDLE_REQUEST = 'FETCH_CUTTING_DC_INWARD_BUNDLE_REQUEST';
export const FETCH_CUTTING_DC_INWARD_BUNDLE_SUCCESS = 'FETCH_CUTTING_DC_INWARD_BUNDLE_SUCCESS';
export const FETCH_CUTTING_DC_INWARD_BUNDLE_FAILURE = 'FETCH_CUTTING_DC_INWARD_BUNDLE_FAILURE';

// FETCH ALL PROPERTIES FROM STITCHING_INWARD DETAILS BY ID
export const FETCH_CUTTING_INWARD_DETAILS_EDIT_QTY_REQUEST = 'FETCH_CUTTING_INWARD_DETAILS_EDIT_QTY_REQUEST';
export const FETCH_CUTTING_INWARD_DETAILS_EDIT_QTY_SUCCESS = 'FETCH_CUTTING_INWARD_DETAILS_EDIT_QTY_SUCCESS';
export const FETCH_CUTTING_INWARD_DETAILS_EDIT_QTY_FAILURE = 'FETCH_CUTTING_INWARD_DETAILS_EDIT_QTY_FAILURE';

// CREATE CUTTING_DC_INWARD DETAILS
export const CREATE_CUTTING_DC_INWARD_DETAILS_REQUEST = 'CREATE_CUTTING_DC_INWARD_DETAILS_REQUEST';
export const CREATE_CUTTING_DC_INWARD_DETAILS_SUCCESS = 'CREATE_CUTTING_DC_INWARD_DETAILS_SUCCESS';
export const CREATE_CUTTING_DC_INWARD_DETAILS_FAILURE = 'CREATE_CUTTING_DC_INWARD_DETAILS_FAILURE';

// UPDATE CUTTING_DC_INWARD DETAILS
export const UPDATE_CUTTING_DC_INWARD_DETAILS_REQUEST = 'UPDATE_CUTTING_DC_INWARD_DETAILS_REQUEST';
export const UPDATE_CUTTING_DC_INWARD_DETAILS_SUCCESS = 'UPDATE_CUTTING_DC_INWARD_DETAILS_SUCCESS';
export const UPDATE_CUTTING_DC_INWARD_DETAILS_FAILURE = 'UPDATE_CUTTING_DC_INWARD_DETAILS_FAILURE';

// FETCH SINGLE STATE OF CUTTING_DC_INWARD DETAILS
export const FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_FAILURE';

// DELETE CUTTING_DC_INWARD DETAILS
export const DELETE_CUTTING_DC_INWARD_DETAILS_REQUEST = 'DELETE_CUTTING_DC_INWARD_DETAILS_REQUEST';
export const DELETE_CUTTING_DC_INWARD_DETAILS_SUCCESS = 'DELETE_CUTTING_DC_INWARD_DETAILS_SUCCESS';
export const DELETE_CUTTING_DC_INWARD_DETAILS_FAILURE = 'DELETE_CUTTING_DC_INWARD_DETAILS_FAILURE';

export const RESET_CUTTING_DC_INWARD_DETAILS_INFO = 'RESET_CUTTING_DC_INWARD_DETAILS_INFO';

export const CREATE_CUTTING_DC_INWARD_DETAILS_FORM = 'CREATE_CUTTING_DC_INWARD_DETAILS_FORM';

export const UPDATE_CUTTING_DC_INWARD_DETAILS_FORM = 'UPDATE_CUTTING_DC_INWARD_DETAILS_FORM';

export const RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD_ID_V2 = 'RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD_ID_V2';
export const SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD_ID = 'SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD_ID';



export const FETCH_CUTTING_INWARD_DETAILS_ID_REQUEST = 'FETCH_CUTTING_INWARD_DETAILS_ID_REQUEST';
export const FETCH_CUTTING_INWARD_DETAILS_ID_SUCCESS = 'FETCH_CUTTING_INWARD_DETAILS_ID_SUCCESS';
export const FETCH_CUTTING_INWARD_DETAILS_ID_FALIURE = 'FETCH_CUTTING_INWARD_DETAILS_ID_FALIURE';


export const FETCH_CUTTING_INWARD_DETAILS_PART_COM_REQUEST = 'FETCH_CUTTING_INWARD_DETAILS_PART_COM_REQUEST';
export const FETCH_CUTTING_INWARD_DETAILS_PART_COM_SUCCESS = 'FETCH_CUTTING_INWARD_DETAILS_PART_COM_SUCCESS';
export const FETCH_CUTTING_INWARD_DETAILS_PART_COM_FALIURE = 'FETCH_CUTTING_INWARD_DETAILS_PART_COM_FALIURE';


export const FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_REQUEST = 'FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_REQUEST';
export const FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_SUCCESS = 'FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_SUCCESS';
export const FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_FALIURE = 'FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_FALIURE';


export const FETCH_POST_BUNDLE_POST_REQUEST = 'FETCH_POST_BUNDLE_POST_REQUEST';
export const FETCH_POST_BUNDLE_POST_SUCCESS = 'FETCH_POST_BUNDLE_POST_SUCCESS';
export const FETCH_POST_BUNDLE_POST_FALIURE = 'FETCH_POST_BUNDLE_POST_FALIURE';


export const FETCH_BUNDLE_INPUT_REQUEST = 'FETCH_BUNDLE_INPUT_REQUEST';
export const FETCH_BUNDLE_INPUT_SUCCESS = 'FETCH_BUNDLE_INPUT_SUCCESS';
export const FETCH_BUNDLE_INPUT_FALIURE = 'FETCH_BUNDLE_INPUT_FALIURE';


export const FETCH_DETAIL_DC_NO_REQUEST = 'FETCH_DETAIL_DC_NO_REQUEST';
export const FETCH_DETAIL_DC_NO_SUCCESS = 'FETCH_DETAIL_DC_NO_SUCCESS';
export const FETCH_DETAIL_DC_NO_FALIURE = 'FETCH_DETAIL_DC_NO_FALIURE';

